<template>
  <custom-dialog
    color="success"
    icon="mdi-plus"
    ref="dialog"
    store-modal
    :title="generateMessage('requests.actions.add_request')"
  >
    <div style="height: 700px; max-height: 60vh;">
      <v-stepper v-model="step" non-linear>
        <v-stepper-header>
          <v-stepper-step
            :complete="!!body.property_id"
            editable
            step="1"
            color="success"
          >
            Choix installation
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step
            editable
            step="2"
            color="success"
            :complete="!!validCustomer"
          >
            Choix Appelant
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable step="3" color="success">
            Création Demande d'intervention
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <div class="d-flex align-center">
              <property-selector
                v-model="body.property_id"
                class="ma-2 caption"
                hide-details
                color="success"
                @input="setPropertyId"
              />
              <v-btn
                small
                color="success"
                class="mx-2 "
                :disabled="!body.property_id"
                @click="confirmProperty"
              >
                Confirmer
              </v-btn>
            </div>
            <v-textarea
              readonly
              outlined
              :value="body.property_id && property.reactive_instructions"
              :loading="isLoadingInstructions"
              label="Consigne Technicien"
              color="success"
            />
            <v-textarea
              readonly
              outlined
              :value="body.property_id && property.operator_instructions"
              :loading="isLoadingInstructions"
              label="Consigne Opérateur"
              color="success"
            />
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-form ref="customerForm" v-model="validCustomer">
              <div class="d-flex align-center">
                <v-select
                  label="Type de client*"
                  class="mx-2 caption"
                  color="success"
                  item-value="id"
                  item-text="name"
                  outlined
                  dense
                  clearable
                  :items="customer_types"
                  :rules="[(v) => !!v || 'Ce champ est obligatoire.']"
                  v-model="body.customer_type"
                />
                <v-btn
                  small
                  color="success"
                  class="mx-2 "
                  :disabled="!validCustomer"
                  @click="confirmCustomer"
                >
                  Confirmer
                </v-btn>
              </div>
              <div class="d-flex">
                <v-select
                  label="Civilité *"
                  class="mx-2 caption flex-grow-0"
                  style="flex-basis: 180px;"
                  color="success"
                  outlined
                  dense
                  :items="customer_civils"
                  :rules="[(v) => !!v || 'Ce champ est obligatoire.']"
                  v-model="body.customer_civil"
                />
                <v-text-field
                  label="Nom *"
                  class="mx-2 caption"
                  color="success"
                  :rules="[
                    (v) => v.length > 0 || 'Ce champ est obligatoire.',
                    (v) => v.length <= 40 || 'Maximum 40 caratères.',
                  ]"
                  outlined
                  v-model="body.customer_name"
                />
                <v-text-field
                  label="Téléphone *"
                  class="mx-2 caption"
                  color="success"
                  :rules="[
                    (v) => v.length > 0 || 'Ce champ est obligatoire.',
                    (v) => v.length <= 15 || 'Maximum 15 caratères.',
                  ]"
                  outlined
                  v-model="body.customer_phone"
                />
              </div>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-form ref="requestForm" v-model="validRequest">
              <div class="d-flex">
                <v-text-field
                  label="Date appel"
                  type="datetime-local"
                  class="mx-2 caption"
                  color="success"
                  readonly
                  outlined
                  v-model="body.signalisation_datetime"
                />
                <v-text-field
                  label="Date limite"
                  type="datetime-local"
                  class="mx-2 caption"
                  color="success"
                  clearable
                  outlined
                  :rules="[
                    (val) =>
                      !val ||
                      val >= this.body.signalisation_datetime ||
                      'La date limite ne peut pas être dans le passé.',
                  ]"
                  v-model="body.limit_datetime"
                />
              </div>
              <div class="d-flex">
                <v-select
                  label="Urgence"
                  class="mx-2 caption flex-grow-1"
                  style="flex-basis: 100px;"
                  color="success"
                  outlined
                  dense
                  item-value="code"
                  :items="urgencies"
                  v-model="body.urgency_code"
                />
                <v-text-field
                  label="Référence Externe"
                  class="mx-2 caption flex-grow-1"
                  style="flex-basis: 100px;"
                  color="success"
                  outlined
                  :rules="[(v) => v.length <= 20 || 'Maximum 20 caratères.']"
                  v-model="body.external_reference"
                />
              </div>
              <div class="d-flex">
                <service-autocomplete
                  placeholder="Symptome *"
                  class="ma-2 caption"
                  idField="code"
                  dense
                  color="success"
                  :use-entities="false"
                  v-model="body.work_order_group_type_code"
                  cache-items
                  item-text="name"
                  item-value="code"
                  :search-attributes-array="['name']"
                  :variable-url="body.property_id | symptomUrl"
                  :disabled="!body.property_id"
                  :rules="[(v) => !!v || 'Ce champ est obligatoire']"
                  @input="onSymptomChange"
                />
                <service-autocomplete
                  placeholder="Qualification *"
                  class="ma-2 caption"
                  idField="code"
                  dense
                  color="success"
                  :use-entities="false"
                  v-model="body.work_order_group_qualif_code"
                  item-text="name"
                  item-value="code"
                  :search-attributes-array="['name']"
                  :variable-url="body.property_id | qualifUrl"
                  :disabled="!body.property_id"
                  :baseAndQueryParams="
                    body.work_order_group_type_code | qualifParams
                  "
                  :rules="[(v) => !!v || 'Ce champ est obligatoire']"
                />
              </div>
              <custom-text-area
                class="mx-2"
                color="success"
                :maxCharacter="3950"
                errorTooLongMsg="Maximun 3950 caractères."
                v-model="body.customer_comment"
                :label="generateMessage('requests.actions.comment')"
              />
            </v-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <template v-slot:actions>
      <div class="d-flex justify-end">
        <v-btn
          small
          color="success"
          :loading="isLoading"
          class="mx-2"
          :disabled="!body.property_id || !validRequest"
          @click="validate"
        >
          {{ generateMessage('requests.actions.validate') }}
        </v-btn>
        <v-btn small class="mx-2" @click="cancel">
          {{ generateMessage('requests.actions.cancel') }}
        </v-btn>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import { formatDateToInputDateTime } from '@/business/utils/dates';
import CustomDialog from '@/components/dialogs/CustomDialog';
import CustomTextArea from '@/components/CustomTextArea';
import PropertySelector from '@/pages/eDispatch/instructions/PropertySelector';
import { LightRequestsService } from '@/services/services/requests.service';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';

const defaultBody = {
  property_id: null,
  customer_civil: null,
  customer_name: '',
  customer_phone: '',
  customer_comment: '',
  customer_type: null,
  work_order_group_type_code: null,
  work_order_group_qualif_code: null,
  urgency_code: null,
  external_reference: '',
  signalisation_datetime: formatDateToInputDateTime(new Date()),
  limit_datetime: null,
};

export default {
  name: 'AddRequestDialog',
  components: {
    CustomDialog,
    CustomTextArea,
    PropertySelector,
    ServiceAutocomplete,
  },
  props: {},
  computed: {
    ...mapGetters({
      property: 'properties_360/current',
      isLoadingProperty: 'properties_360/isLoadingCurrent',
      isModalOpen: 'modal/isOpen',
    }),
    isLoadingInstructions() {
      return this.body.property_id && this.isLoadingProperty;
    },
  },
  filters: {
    displayDuration(hour) {
      if (hour && hour > 0) {
        const h = Math.trunc(hour);
        const min = Math.trunc(hour * 60) - 60 * h;
        return `${h !== 0 ? `${h}h` : ''}${
          h !== 0 && min < 10 ? `0${min}` : min
        }min`;
      }
      return '';
    },
    symptomUrl(id) {
      return id
        ? `${process.env.P2C_BASE_URI}/properties/${id}/work_order_group_types`
        : null;
    },
    qualifUrl(id) {
      return id
        ? `${process.env.P2C_BASE_URI}/properties/${id}/work_order_group_qualifications`
        : null;
    },
    qualifParams(id) {
      return id ? [{ work_order_group_type_code: { $eq: id } }] : [];
    },
  },
  methods: {
    ...mapActions({
      setFilterAttributeSymptomQualif:
        'requests/history/qualifications/setFilterAttribute',
      initCurrentProperty: 'properties_360/initCurrent',
      setSnackbarOpen: 'snackbar/setSnackbarOpen',
    }),
    formatDateToInputDateTime,
    generateMessage,
    setPropertyId(id) {
      if (id) {
        this.initCurrentProperty(id);
      }
      this.body.work_order_group_type_code = null;
      this.body.work_order_group_qualif_code = null;
      this.$refs.customerForm.resetValidation();
      this.$refs.requestForm.resetValidation();
    },
    onSymptomChange() {
      this.body.work_order_group_qualif_code = null;
    },
    confirmProperty() {
      this.step = 2;
    },
    confirmCustomer() {
      this.step = 3;
    },
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    resetForm() {
      this.step = 1;
      this.body = { ...defaultBody };
      this.$refs.customerForm.resetValidation();
      this.$refs.requestForm.resetValidation();
    },
    validate() {
      this.isLoading = true;
      LightRequestsService.createItem(this.body)
        .then((response) => {
          this.setSnackbarOpen({
            message: response.message,
            color: 'success',
            closeable: true,
          });
          this.resetForm();
          this.cancel();
        })
        .catch((err) => {
          this.setSnackbarOpen(catchCRUDError('ADD', err));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  data() {
    return {
      validCustomer: false,
      validRequest: false,
      step: 1,
      isLoading: false,
      body: { ...defaultBody },
      customer_civils: [
        { value: 1, text: 'Mr' },
        { value: 2, text: 'Mme' },
      ],
      urgencies: [
        { code: 1, text: 'Prioritaire' },
        { code: 2, text: 'Important' },
        { code: 3, text: 'Moyen' },
        { code: 4, text: 'Faible' },
      ],
      customer_types: [
        { id: 'CLI', name: 'CLI - Client' },
        { id: 'CRG', name: 'CRG - Concierge' },
        { id: 'POR', name: 'POR - Portail Client' },
        { id: 'LOC', name: 'LOC - Locataire - propiétaire' },
        { id: 'TEC', name: 'TEC - Technicien' },
        { id: 'TTS', name: 'TTS - Transmetteur de télésurveillance' },
        { id: 'SST', name: 'SST - Société de surveillance' },
        { id: 'XXX', name: 'XXX - Autre' },
      ],
    };
  },
};
</script>
